import { CircularProgress, Typography } from '@mui/material'
import React from 'react'
import { useStyles } from '../style'

const Pending = () => {
  const classes = useStyles()

  return (
    <>
      <Typography className={classes.heading}>
        <CircularProgress size={25} /> Verifying your email address
      </Typography>
    </>
  )
}

export default Pending
